import { mockComponent } from 'bloko/common/setupMockComponents';

export { default as ModalHeader } from 'bloko/blocks/modal/ModalHeader';
export { default as ModalFooter } from 'bloko/blocks/modal/ModalFooter';
export { default as ModalTitle } from 'bloko/blocks/modal/ModalTitle';
export { default as ModalError } from 'bloko/blocks/modal/Error';
export { default as ModalContent } from 'bloko/blocks/modal/ModalContent';

export default mockComponent('Modal', null, { withChildren: true });
